/** @format */
import React from 'react';
import { FormControl, InputLabel, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import InputBase from '@mui/material/InputBase';
import { withStyles } from '@mui/styles';
import { useStyles } from './style';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
    '& .MuiSelect-nativeInput': {
      padding: '1.5px 4px',
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    border: '1px solid #b0bec5',
    padding: '10px 12px',
    fontFamily: 'Vazir',
    '&::placeholder': {
      direction: 'ltr',
      textAlign: 'left',
    },
  },
}))(InputBase);

const Select2 = ({ value, options, onChange, label = null, ...rest }) => {
  const classes = useStyles();

  const id = `select-label-${label}`;

  return (
    <FormControl {...rest}>
      <InputLabel shrink id={`id-${label}`} className={classes.label}>
        {label}
      </InputLabel>
      <Select
        labelId={`id-${label}`}
        id={id}
        input={<BootstrapInput label={null} variant="outlined" />}
        value={value}
        onChange={onChange}
      >
        {options.map((item, key) => (
          <MenuItem key={key} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Select2;
